(function ( $ ) {
     $.fn.menuLink = function (options) {
         var settings = $.extend({
            someOption: ""
        }, options);

        var objLink    = $('a.mobilNav');
        var opened     = false;
        var closeLink  = $('.closeSideBar');

        function _init() {
            $( objLink ).click(function() {
                if(opened == false){
                    _openNavigation();
                }else{
                    _closeNavigation();
                }
            });
            $( closeLink ).click(function() {
                _closeNavigation();
            })
        }

        function _closeNavigation(){
            $('body').removeClass('locked');
            $('#sideBar').removeClass('active');
            $('#sideBarNav').removeClass('active');
            opened = false;
        }

        function _openNavigation(){
            $('body').addClass('locked');
            $('#sideBar').addClass('active');
            $('#sideBarNav').addClass('active');
            opened = true;
        }

        _init();

       return {
         reload:_init,
       };
    };
}( jQuery ));

$("body").menuLink();


(function ( $ ) {
     $.fn.menuJump = function (options) {
         var settings = $.extend({
            someOption: ""
        }, options);


        function _init() {
            $('.java-link').click(function(e) {
                e.preventDefault();
                val = $(this).attr('href');
                $('.java-link[href="'+val+'"]').addClass('active');
                $('.java-link[href!="'+val+'"]').removeClass('active');

                $('.l-list').addClass('d-none');
                $('#'+val).removeClass('d-none');

                $([document.documentElement, document.body]).animate({
                    scrollTop: $("#who-hook").offset().top-25
                }, 500);
            });
        }

        _init();

       return {
         reload:_init,
       };
    };
}( jQuery ));

$("body").menuJump();
